module.exports = __webpack_public_path__ + "img/elemento_pc_down.251864f0.svg";